import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "@needl-ai/common/lib/axios";

const NEEDLDRIVE_QUERY_KEY = "needldrive";

export const useFetchNeedlDrive = (
  params: NeedlDriveParams,
  enabled = false
) => {
  return useQuery({
    queryKey: [NEEDLDRIVE_QUERY_KEY, params],
    queryFn: async (): Promise<NeedlDriveResponse> => {
      const response = await axiosInstance.get("/doc/needldrive", {
        params,
      });
      return response.data;
    },
    enabled: enabled && !!params.deeplink && !!params.access_key,
  });
};

type NeedlDriveParams = {
  deeplink: string;
  access_key: string;
};

type NeedlDriveResponse = {
  timestamp: string;
  txnId: string;
  results: NeedlDriveDocument[];
  query_params: {
    deeplink: string;
    access_key: string;
  };
};

type NeedlDriveDocument = {
  category: string;
  category_tab: string;
  deeplink: string;
  doc_id: string;
  domain: string | null;
  external_access_link: string | null;
  generalized_mime_type: string;
  highlights: string[];
  image_location: string[];
  last_modified_time_at_source: number;
  mime_type: string;
  note_title: string | null;
  notebook: string | null;
  object_location: string;
  original_document_link: string | null;
  original_document_mime: string | null;
  original_filename: string[];
  retained_link_to_resources: string[];
  retained_sources: string[];
  score: number;
  selected: boolean;
  sender_group: string;
  sender_name: string;
  sender_name_ua: string;
  source: string;
  source_details: Record<string, unknown>;
  sources: string[];
  suggested_sender_name_ua: string | null;
  tags: string;
  tags_ua: string;
  unix: number;
  upload_client: string;
  user_name: string;
  access_key: string;
};
